import React from "react";

const Footer = (props) => {
  return (
    <footer id="footer">
      <div className="container">
        <div className="social-links">
          <a target="_blank" rel="noreferrer" href="https://www.facebook.com/kunal.karnik89/" className="facebook"><i className="bx bxl-facebook" /></a>
          <a target="_blank" rel="noreferrer" href="https://www.instagram.com/kunal.karnik89/" className="instagram"><i className="bx bxl-instagram" /></a>
          <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/kunal-karnik-a709b045/" className="linkedin"><i className="bx bxl-linkedin" /></a>
          <a target="_blank" rel="noreferrer" href="https://github.com/Kunal-Karnik" className="github"><i className="bx bxl-github" /></a>
        </div>
        <div className="copyright">
          © 2025 <strong><span>Kunal M Karnik</span></strong>
        </div>
        <div className="credits">
          Built with React &amp; Bootstrap
        </div>
      </div>
    </footer>
  )
}

export default Footer;